
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wybierz-numer",
      function () {
        return require("private-next-pages/wybierz-numer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wybierz-numer"])
      });
    }
  